import { render, staticRenderFns } from "./IndicadoresResumoArmazem.vue?vue&type=template&id=c4556d8e&scoped=true&"
import script from "./IndicadoresResumoArmazem.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoArmazem.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoArmazem.vue?vue&type=style&index=0&id=c4556d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4556d8e",
  null
  
)

export default component.exports